module.exports = __webpack_public_path__ + "img/H01121-84.87c6a40a.jpg";